import React from 'react';
import PropTypes from 'prop-types';

export class Modal extends React.Component {
  componentDidMount = () => {
    setTimeout(() => {
      this.props.fadeIn();
    }, 300);
  };
}

Modal.propTypes = {
  fadeIn: PropTypes.func,
  clickCancel: PropTypes.func,
};
